module.exports = __webpack_public_path__ + "img/logo.d7f710fd.svg";